import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-searchinput', 'clear', 'Išvalyti įvestį');
Labels.set('ui-searchinput', 'search', 'Paieška');
